module.exports = __webpack_public_path__ + "img/hugeicon-filter.2e928960.svg";